import api from './api';

export interface ClockInPayload {
    workspaceId: string;
    teamId?: string;
    mode: 'office' | 'wfh' | 'wfa' | 'visit';
    lat?: number;
    lng?: number;
    accuracy?: number;
    ssid?: string;
    visitTarget?: string;
    note?: string;
    officeId?: string;
    // Anti-fraud (best-effort, server yang verifikasi descriptor)
    deviceFingerprint?: string;
    faceDescriptor?: number[]; // 128 float dari face-api lokal
    livenessPassed?: boolean;
}

export interface ClockOutPayload {
    workspaceId: string;
    lat?: number;
    lng?: number;
    note?: string;
    deviceFingerprint?: string;
    faceDescriptor?: number[];
    livenessPassed?: boolean;
}

export const attendanceService = {
    today: (workspaceId: string) => api.get('/attendance/today', { params: { workspaceId } }),
    stats: (workspaceId: string) => api.get('/attendance/stats', { params: { workspaceId } }),
    list: (params: { workspaceId: string; userId?: string; from?: string; to?: string }) =>
        api.get('/attendance', { params }),
    listOffices: (workspaceId: string) => api.get('/attendance/offices', { params: { workspaceId } }),
    clockIn: (data: ClockInPayload) => api.post('/attendance/clock-in', data),
    clockOut: (data: ClockOutPayload) => api.post('/attendance/clock-out', data),
    myPolicy: (workspaceId: string) => api.get('/attendance/policy/me', { params: { workspaceId } }),

    // ── Face enrollment (anti-fraud) ──
    /** Simpan / ganti descriptor wajah referensi (128 float). */
    enrollFace: (workspaceId: string, descriptor: number[]) =>
        api.post('/attendance/face/enroll', { workspaceId, descriptor }),
    /** Status enrollment wajah user saat ini: { enrolled: boolean, updatedAt?: string }. */
    faceStatus: () => api.get('/attendance/face/me'),
};
